export default __webpack_public_path__ + "static/media/statusInProgress.b12ed9a8.png";